export enum MaterialIcon {
	ADD = 'add',
	ANNOUNCEMENT = 'announcement',
	ADD_LOCATION = 'add_location',
	ASSIGN = 'how_to_reg',
	BRIGHTNESS_HIGH = 'brightness_high',
	BRIGHTNESS_LOW = 'brightness_low',
	BRIGHTNESS_MEDIUM = 'brightness_medium',
	CHECK = 'check',
	CHECK_BOX = 'check_box_outline_blank',
	CHECK_BOX_INDETERMINATE = 'indeterminate_check_box',
	CHECK_BOX_SELECTED = 'check_box',
	CHECK_CIRCLE = 'check_circle_outline',
	CLOSE = 'close',
	CONTENT_COPY = 'content_copy',
	CONTENT_PASTE = 'content_paste',
	DATE = 'date_range',
	BEARING = 'nat',
	DASHBOARD = 'dashboard',
	DELETE = 'delete',
	DEPARTMENT = 'domain',
	DONE_ALL = 'done_all',
	DUPLICATE = 'file_copy',
	EDIT = 'mode_edit',
	EDIT_LOCATION = 'edit_location',
	EXIT_TO_APP = 'exit_to_app',
	FIELD_FORM = 'ballot',
	FIELD_HEIGHT = 'vertical_align_top',
	FIELD_IMAGE = 'photo_camera',
	FIELD_LOCATION = 'my_location',
	FIELD_NESTED_LIST = 'view_quilt',
	FIELD_NUMBER = 'looks_one',
	FIELD_ORIENTATION = 'explore',
	FIELD_SELECT_LIST = 'view_list',
	FIELD_TEXT = 'font_download',
	FIELD_TRUE_SIZE = 'camera',
	FIELD_VECTOR = 'directions',
	FILE_DOWNLOAD = 'file_download',
	FILE_UPLOAD = 'file_upload',
	FILTER_NONE = 'filter_none',
	FOLDER = 'folder',
	FOLDER_OPEN = 'folder_open',
	GPS_FIXED = 'gps_fixed',
	GPS_OFF = 'gps_off',
	GPS_ON = 'gps_not_fixed',
	INBOX = 'inbox',
	HELP = 'help',
	HELP_OUTLINE = 'help_outline',
	INFO = 'info_outline',
	INFO_FILLED = 'info',
	KEY_DOWN = 'keyboard_arrow_down',
	KEY_LEFT = 'keyboard_arrow_left',
	KEY_RIGHT = 'keyboard_arrow_right',
	KEY_UP = 'keyboard_arrow_up',
	LASER = 'flare',
	HEIGHT = 'height',
	LINEAR_SCALE = 'linear_scale',
	LOCATION = 'location_on',
	LOCK = 'lock',
	MAGIC_WAND = 'auto_fix_high',
	MANAGE_HISTORY = 'manage_history',
	MAP = 'map',
	MASK = 'select_all',
	MORE_VERT = 'more_vert',
	MOVE = 'forward',
	MOVE_DOWN = 'move_down',
	MENU = 'menu',
	NAVIGATE_NEXT = 'navigate_next',
	NAVIGATE_PREV = 'navigate_before',
	NONE = '',
	ORG_SEARCH = 'youtube_searched_for',
	PERSON = 'person',
	PERSON_BLACK = 'person_black',
	PHOTO_MEASURE = 'straighten',
	POLE_BASE = 'vertical_align_bottom',
	PUBLIC = 'public',
	RADIO = 'radio_button_unchecked',
	RADIO_SELECTED = 'radio_button_checked',
	SAVE = 'save_alt',
	SEARCH = 'search',
	SELECT = 'call_made',
	SPARKLE = 'auto_awesome',
	MASK_BLUR = 'deblur',
	HIDE_PHOTO = 'hide_image',
	SHORT_TEXT = 'short_text',
	SORT = 'sort_by_alpha',
	SPAN_LINK = 'format_size',
	STATUS = 'flag',
	TAG = 'more',
	TAG_GROUP = 'group_work',
	UPDATE = 'update',
	VERTICAL_DISTRIBUTE = 'vertical_distribute',
	VERTICAL_SEPARATION = 'swap_vert',
	VISIBILITY_OFF = 'visibility_off',
	ZOOM_IN = 'zoom_in',
	ZOOM_OUT = 'zoom_out',
	ZOOM_OUT_MAP = 'zoom_out_map',
	SET_CROP = 'aspect_ratio',
	REMOVE = 'remove',
	SQUARE_FOOT = 'square_foot',
	FORM_UPDATE = 'assignment_turned_in',
	CLOUD_UPLOAD = 'cloud_upload',
	FIELD_ANCHOR = 'architecture',
	WARNING = 'warning',
	VISIBILITY = 'visibility',
	DESCRIPTION = 'description',
	PLAY_CIRCLE = 'play_circle',
	PAUSE_CIRCLE = 'pause_circle',
	SUPPORT = 'support',
	CONTACT_SUPPORT = 'contact_support',
	PRINT = 'print',
}
